import { useRouterState } from "@tanstack/react-router";
import { getMessages } from "@/lib/i18n";
import { resolveSiteContext } from "@/lib/site";

export function useSite() {
  const href = useRouterState({ select: (state) => state.location.href });
  const site = resolveSiteContext(href);
  return { site, messages: getMessages(site.locale), href };
}
